import { route, string } from 'react-router-typesafe-routes/dom'
const base = 'et/company/:companyId/configuration' as const
const companyOnly = { companyId: string().defined() }

export const SETTINGS_ROUTES = {
  basic: route(`${base}/basic`, { params: companyOnly }),
  businessTrip: route(`${base}/business-trip`, { params: companyOnly }),
  businessTripRates: route(`${base}/business-trip-rates`, { params: companyOnly }),
  timesheetBasic: route(`${base}/timesheet-basic`, { params: companyOnly }),
  timesheetAdditional: route(`${base}/timesheet-additional`, { params: companyOnly }),
  minimumWage: route(`${base}/minimum-wage`, { params: companyOnly }),
  minimumWageCountry: route(`${base}/minimum-wage/:country`, {
    params: { ...companyOnly, country: string().defined() },
  }),
  violation: route(`${base}/violation`, { params: companyOnly }),
  exchangeRate: route(`${base}/exchange-rate`, { params: companyOnly }),
  country: route(`${base}/country`, { params: companyOnly }),
  printout: route(`${base}/printout`, { params: companyOnly }),
  alertReminders: route(`${base}/alert-reminders`, { params: companyOnly }),
  gps: route(`${base}/gps`, { params: companyOnly }),
  scanner: route(`${base}/scanner`, { params: companyOnly }),
  integration: route(`${base}/integration`, { params: companyOnly }),
  emailConfiguration: route(`${base}/email-configuration`, { params: companyOnly }),
  payrollModule: route(`${base}/payroll-module`, { params: companyOnly }),
}
